import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNocircleCheckApproved = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 12.4L9 17.5L20 6.5",
		stroke: "black",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgNocircleCheckApproved;
